import React, { useState } from "react";
import Scrollspy from "react-scrollspy";

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 68) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <div className={navbar ? "landing-menu fixed" : "landing-menu"}>
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between">
          <div className="logo order-md-1">
            <a href="#product">
              <img src="/images/logo/logo.svg" alt="home-demo" />
            </a>
          </div>
          {/* End logo */}

          <div className="order-md-3 d-flex align-items-center">


            <div className="mob-header">
              <button className="toggler-menu" onClick={handleClick}>
                <div className={click ? "active" : ""}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
            </div>
            {/* End Header */}
          </div>
          {/* End div */}

          <nav
            id="feature-menu"
            className="landing-mobile_menu navbar navbar-expand-sm order-md-2 "
          >
            <div className="m-auto nav-container">
              <div id="navbarSupportedContent">
                <Scrollspy
                  className="navbar-nav"
                  id="theme-menu-list"
                  items={[
                    "product",
                    "features",
                    "why",
                    "cta",
                  ]}
                  currentClassName="active"
                  offset={-65}
                >
                  <li className="nav-item">
                    <a href="#product" className="nav-link">
                      Το προϊόν
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#features" className="nav-link">
                      Βασικές Λειτουργίες
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#why" className="nav-link">
                      Γιατί Salonify;
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#cta" className="nav-link">
                      Προεγγραφή
                    </a>
                  </li>

                </Scrollspy>
              </div>
            </div>
          </nav>
          {/* #feature-menu */}

          {/* Mobile Menu Start */}
          <div className={click ? "mobile-menu menu-open" : "mobile-menu"}>
            <div className="logo order-md-1">
              <a href="#product">
                <img src="/images/logo/logo.svg" alt="home-demo" />
              </a>
              <div className="fix-icon text-dark" onClick={handleClick}>
                <img src="images/icon/close.svg" alt="icon" />
              </div>
              {/* Mobile Menu close icon */}
            </div>

            <Scrollspy
              className="navbar-nav"
              id="theme-menu-list"
              items={[
                "product",
                "features",
                "why",
                "cta",
              ]}
              currentClassName="active"
              offset={-200}
            >
              <li className="nav-item">
                <a href="#product" className="nav-link" onClick={handleClick}>
                  Το προϊόν
                </a>
              </li>
              <li className="nav-item">
                <a href="#features" className="nav-link" onClick={handleClick}>
                Βασικές Λειτουργίες
                </a>
              </li>
              <li className="nav-item">
                <a href="#why" className="nav-link" onClick={handleClick}>
                  Γιατί Salonify;
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#cta"
                  className="nav-link"
                  onClick={handleClick}
                >
                  Προεγγραφή
                </a>
              </li>
            </Scrollspy>
          </div>
          {/* Mobile Menu End */}
        </div>
      </div>
    </div>
  );
};

export default Header;
